// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3DJVh","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__LTmaN"};